import '@snipit/core/utils/prism-bundle.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@snipit/core/context/AuthContext'
import App from './App.jsx'
import './index.css'
import '@snipit/core/i18n.js'
import { registerSW } from 'virtual:pwa-register'

if ('serviceWorker' in navigator) {
  registerSW({ immediate: true })
}

import { app } from '@snipit/core/services/firebase'
import { getPerformance } from 'firebase/performance'
getPerformance(app);

window.__IS_WEB__ = true;

// Global Polyfill for chrome.storage.local in web environment
if (!window.chrome) {
    window.chrome = {};
}
if (!window.chrome.storage) {
    window.chrome.storage = {
        local: {
            get: (keys, callback) => {
                const res = {};
                keys.forEach(k => {
                    const val = localStorage.getItem(k);
                    if (val) {
                        try { res[k] = JSON.parse(val); } catch (e) { res[k] = val; }
                    }
                });
                callback(res);
            },
            set: (data, callback) => {
                const changes = {};
                Object.keys(data).forEach(k => {
                    localStorage.setItem(k, JSON.stringify(data[k]));
                    changes[k] = { newValue: data[k] };
                });
                if (window.chrome.storage.onChanged && window.chrome.storage.onChanged._listeners) {
                    window.chrome.storage.onChanged._listeners.forEach(fn => fn(changes, 'local'));
                }
                if (callback) callback();
            }
        },
        onChanged: {
            _listeners: [],
            addListener: function(fn) { this._listeners.push(fn); },
            removeListener: function(fn) { this._listeners = this._listeners.filter(l => l !== fn); }
        }
    };
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-6 bg-[#121212] text-red-400 h-screen font-sans flex flex-col justify-center items-center text-center">
                    <h1 className="text-xl font-bold mb-2">SnipIT Encountered an Error</h1>
                    <p className="text-sm text-gray-400 mb-6">A UI component failed to load.</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="bg-red-900/30 px-4 py-2 rounded border border-red-900/60 hover:bg-red-900/50 text-white transition-colors"
                    >
                        Reload App
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ErrorBoundary>
            <AuthProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </AuthProvider>
        </ErrorBoundary>
    </React.StrictMode>,
)
